import { getServiceUrl } from "../api";
import RequestService from "../httpRequest";

export default {
  getApplyList(params, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/customApply/page`)
      .method("GET")
      .data(params)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("获取定制音色申请列表失败:", err);
        RequestService.reAjaxFun(() => {
          this.getApplyList(params, callback);
        });
      })
      .send();
  },

  getApplyAudioUuid(id, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/customApply/audioId/${id}`)
      .method("POST")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("获取申请原音播放凭证失败:", err);
        RequestService.reAjaxFun(() => {
          this.getApplyAudioUuid(id, callback);
        });
      })
      .send();
  },

  getPlayApplyUrl(uuid) {
    return `${getServiceUrl()}/voiceClone/customApply/play/${uuid}`;
  },

  getPreviewAudioBlob(url, successCallback, failCallback) {
    RequestService.sendRequest()
      .url(url)
      .method("GET")
      .type("blob")
      .success((res) => {
        RequestService.clearRequestTime();
        if (res.data && successCallback) successCallback(res.data);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (failCallback) failCallback(res);
      })
      .networkFail((err) => {
        console.error("获取试听音频失败:", err);
        if (failCallback) failCallback(err);
      })
      .send();
  },

  cloneApply(id, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/customApply/${id}/clone`)
      .method("POST")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (failCallback) failCallback(res);
        else callback(res);
      })
      .networkFail((err) => {
        console.error("克隆申请失败:", err);
        RequestService.reAjaxFun(() => {
          this.cloneApply(id, callback, failCallback);
        });
      })
      .send();
  },

  deleteClonedBatch(ids, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/customApply/deleteClone`)
      .method("POST")
      .data({ ids })
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (failCallback) failCallback(res);
        else callback(res);
      })
      .networkFail((err) => {
        console.error("删除克隆音色失败:", err);
        RequestService.reAjaxFun(() => {
          this.deleteClonedBatch(ids, callback, failCallback);
        });
      })
      .send();
  },

  deleteRecordsBatch(ids, callback, failCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/customApply/delete`)
      .method("POST")
      .data({ ids })
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (failCallback) failCallback(res);
        else callback(res);
      })
      .networkFail((err) => {
        console.error("删除申请记录失败:", err);
        RequestService.reAjaxFun(() => {
          this.deleteRecordsBatch(ids, callback, failCallback);
        });
      })
      .send();
  },
};
